import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/comics';

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % heroSlides.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <img
            src={slide.cover}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
        </div>
      ))}

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium mb-4">
                <i className="ri-fire-line"></i>
                <span>热门推荐</span>
              </div>
              <h2 className="text-2xl md:text-4xl font-bold text-white mb-3 font-heading leading-tight">
                {heroSlides[current].title}
              </h2>
              <p className="text-sm md:text-base text-white/80 mb-6 leading-relaxed">
                {heroSlides[current].subtitle}
              </p>
              <div className="flex items-center gap-3 flex-wrap">
                <Link
                  to={`/article/${heroSlides[current].comicId}`}
                  className="px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
                >
                  立即阅读
                </Link>
                <Link
                  to="/category/all"
                  className="px-6 py-3 bg-white/20 backdrop-blur-sm text-white rounded-full text-sm font-medium hover:bg-white/30 transition-colors duration-200 whitespace-nowrap"
                >
                  浏览更多
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/35 transition-colors duration-200"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/35 transition-colors duration-200"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === current ? 'w-6 bg-white' : 'bg-white/50'
            }`}
            aria-label={`切换到第 ${index + 1} 张`}
          />
        ))}
      </div>
    </section>
  );
}